<template>
  <div class="policyDocuments">
    <div class="t">
      <a-tabs v-model="activeName">
        <a-tab-pane tab="政策文件" key="policyDocuments"></a-tab-pane>
      </a-tabs>
      <div class="city">
        <span>所在地区：</span>
        <!-- <a-button type="link" class="padding_none">
          {{ listTreeCityObj.name }}
          <a-icon type="caret-down" />
        </a-button> -->
        <span>
          <a-cascader
            :field-names="{
              label: 'name',
              value: 'id',
              children: 'children',
            }"
            :options="treeCityList"
            @change="onListTreeCityChange"
          >
            <a-button type="link" class="padding_none">
              {{ listTreeCityObj.name }}
              <a-icon type="caret-down" />
            </a-button>
          </a-cascader>
        </span>
      </div>
      <div class="filter_item" :class="{ policyArea_more: !isProjectCat }">
        <span class="title">文件类型：</span>
        <div>
          <span
            class="option_item"
            @click="changeProjectCat(item)"
            :class="{ active: projectCat_active == item.id }"
            v-for="(item, index) in projectCat"
            :key="index + 'policyArea'"
          >
            {{ item.name }}
          </span>
        </div>
        <a-button
          type="link"
          v-show="!isProjectCat"
          @click="isProjectCat = !isProjectCat"
        >
          更多
          <a-icon type="down" />
        </a-button>
        <a-button
          type="link"
          v-show="isProjectCat"
          @click="isProjectCat = !isProjectCat"
        >
          收起
          <a-icon type="up" />
        </a-button>
      </div>
      <div class="filter_item" :class="{ policyArea_more: !isPolicyArea }">
        <span class="title">政策区域：</span>
        <div>
          <span
            class="option_item"
            @click="changePolicyArea(item)"
            :class="{ active: policyArea_active == item.id }"
            v-for="(item, index) in policyArea"
            :key="index + 'policyArea'"
          >
            {{ item.name }}
          </span>
        </div>
        <a-button
          type="link"
          v-show="!isPolicyArea"
          @click="isPolicyArea = !isPolicyArea"
        >
          更多
          <a-icon type="down" />
        </a-button>
        <a-button
          type="link"
          v-show="isPolicyArea"
          @click="isPolicyArea = !isPolicyArea"
        >
          收起
          <a-icon type="up" />
        </a-button>
      </div>
      <div class="filter_item" :class="{ policyArea_more: !isAcceptDept }">
        <span class="title">受理部门：</span>
        <div>
          <span
            class="option_item"
            @click="changeAcceptDept(item)"
            :class="{ active: acceptDept_active == item.id }"
            v-for="(item, index) in acceptDept"
            :key="index + 'policyArea'"
          >
            {{ item.name }}
          </span>
        </div>
        <a-button
          type="link"
          v-show="!isAcceptDept"
          @click="isAcceptDept = !isAcceptDept"
        >
          更多
          <a-icon type="down" />
        </a-button>
        <a-button
          type="link"
          v-show="isAcceptDept"
          @click="isAcceptDept = !isAcceptDept"
        >
          收起
          <a-icon type="up" />
        </a-button>
      </div>
      <div>
        <span class="text-r">关键词：</span>
        <input
          v-model.trim="filterList.keyword"
          type="text"
          class="search"
          placeholder="请输入关键词"
          @keyup.enter="search()"
        />
        <!-- <a-icon type="search" class="search_icon" @click="search()" /> -->
        <svg-icon
          icon-class="search1"
          class="search_icon"
          @click="search()"
        ></svg-icon>
      </div>
    </div>
    <div class="line"></div>
    <div class="b" id="b">
      <div class="flex">
        <div class="totalColor">
          共为您检索到
          <span>{{ filterList.total }}</span> 条记录
        </div>
        <a-select default-value=" " style="width: 130px" @change="handleChange">
          <a-select-option value=" ">全部时间</a-select-option>
          <a-select-option value="7"> 【最近7天】 </a-select-option>
          <a-select-option value="30"> 【最近30天】 </a-select-option>
        </a-select>
      </div>
      <div class="table">
        <a-table
          :loading="loading"
          row-key="IdentityId"
          :scroll="{ y: tableHeight }"
          :columns="columns"
          :data-source="tableData"
          :pagination="{
            pageSize: filterList.pageSize,
            current: filterList.pageNum,
            total: filterList.total,
            showQuickJumper: true, //显示跳转页数
            showSizeChanger: true, // 显示可改变每页数量
            pageSizeOptions: ['10', '20'], // 每页数量选项
            showTotal: (total) => `共 ${filterList.total} 条`, //显示总数
          }"
          @change="showSizeChange"
        >
          <span
            :title="text.Title"
            slot="name"
            slot-scope="text"
            class="cursor"
            @click="redirect(text)"
            :class="{ text_tag: text.tag !== undefined }"
          >
            {{ text.Title }}
          </span>
          <span slot="PublishTime" slot-scope="text">
            {{ text.substr(0, 10) }}
          </span>
        </a-table>
      </div>
    </div>
  </div>
</template>

<script>
import {
  outerList,
  listTreeCityOnlyBeijing,
  typeList,
  listPolicyAreasList,
} from "@/api/policyDocuments";
const columns = [
  {
    title: "文件标题",
    scopedSlots: { customRender: "name" },
    ellipsis: true,
    align: "left",
    key: "Title",
  },
  {
    title: "发文部门",
    dataIndex: "Dept",
    key: "Dept",
    width: 400,
  },
  {
    title: "发布日期",
    dataIndex: "PublishTime",
    key: "PublishTime",
    ellipsis: true,
    width: 250,
    scopedSlots: { customRender: "PublishTime" },
  },
];

export default {
  name: "policyDocuments",
  data() {
    return {
      tableHeight: 360,
      tableData: [],
      treeCityList: [],
      listTreeCityObj: {
        name: "",
        id: "",
      },
      columns,
      activeName: "policyDocuments",
      loading: false,
      isPolicyArea: false,
      isProjectCat: false,
      isAcceptDept: false,
      filterList: {
        keyword: "",
        pageSize: 20,
        pageNum: 1,
        total: 0,
        areaCode: "", //政策区域CODE
        deptFullName: "", //受理部门
        chaplateValue: "", //文件类型
        beginTime: "", //开始时间
        endTime: "", //结束时间
        days: "",
      },
      policyArea: [
        {
          id: 0,
          name: "全部",
        },
        {
          id: 1,
          name: "部委项目",
        },
        {
          id: 2,
          name: "北京市",
        },
      ],
      policyArea_active: "",
      projectCat: [
        {
          id: 0,
          name: "全部",
        },
        {
          id: 1,
          name: "申报通知",
        },
        {
          id: 2,
          name: "公示公告",
        },
        {
          id: 3,
          name: "政策法规",
        },
      ],
      projectCat_active: "",
      acceptDept: [
        {
          id: 0,
          name: "全部",
        },
        {
          id: 1,
          name: "北京市商务局",
        },
        {
          id: 2,
          name: "北京市经济和信息化局",
        },
      ],
      acceptDept_active: "",
    };
  },
  methods: {
    //政策区域
    changePolicyArea(item) {
      if (item.id) {
        this.filterList.areaCode = item.id;
      } else {
        this.filterList.areaCode = this.listTreeCityObj.id;
      }
      this.policyArea_active = item.id;
      this.search();
    },
    //文件类型
    changeProjectCat(item) {
      this.filterList.chaplateValue = item.value;
      this.projectCat_active = item.id;
      this.search();
    },
    //受理部门
    changeAcceptDept(item) {
      this.filterList.deptFullName = this.acceptDept_active = item.id;
      this.search();
    },
    //选择所在地区
    onListTreeCityChange(value, selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1];
      this.getListPolicyAreasData(targetOption);
    },
    handleChange(value) {
      this.filterList.days = value;
      this.search();
    },
    //跳转详情
    redirect(text) {
      if (text.IdentityId && !text.tag) {
        this.$router.push({
          path: "/policyDocumentsDetail?targetId=" + text.IdentityId,
        });
      }
    },
    getArr(obj) {
      let arr = [{ id: "", name: "全部" }];
      for (const key in obj) {
        if (Object.hasOwnProperty.call(obj, key)) {
          const el = obj[key];
          arr.push({
            id: key,
            name: el,
          });
        }
      }
      return arr;
    },
    search() {
      this.filterList.pageNum = 1;
      this.getTableData();
    },
    async getListPolicyAreasData(obj) {
      this.listTreeCityObj = obj;
      this.filterList.areaCode = obj.id;
      const listPolicyAreasListData = await listPolicyAreasList({
        cityCode: "",
        currentAreaCode: obj.id,
      });
      this.policyArea = this.getArr(listPolicyAreasListData.data.policyArea);
      this.acceptDept = this.getArr(listPolicyAreasListData.data.receivingDept);
      await this.getTableData();
    },
    async getTableData() {
      this.loading = true;
      try {
        const {
          days,
          keyword,
          areaCode,
          deptFullName,
          chaplateValue,
          beginTime,
          endTime,
          pageNum,
          pageSize,
        } = this.filterList;
        const res = await outerList({
          days,
          keyword,
          areaCode,
          deptFullName,
          chaplateValue,
          beginTime,
          endTime,
          pageNum,
          pageSize,
        });
        this.loading = false;
        this.filterList.total = res.data.total;
        this.tableData = res.data.list;
        // if (pageNum === 1) {
        //   this.tableData.unshift({
        //     IdentityId: new Date().toLocaleTimeString(),
        //     Title: "下面对不齐是符号问题",
        //     Dept: "是的归属感颂德歌功问题十",
        //     PublishTime: new Date()
        //       .toLocaleDateString()
        //       .replaceAll("/", "-")
        //       .split("-")
        //       .map(el => {
        //         return el.padStart(2, 0);
        //       })
        //       .join("-"),
        //     tag: true
        //   });
        // }
      } catch (error) {
        this.loading = false;
      }
    },
    showSizeChange({ current, pageSize }) {
      this.filterList.pageSize = pageSize;
      this.filterList.pageNum = current;
      this.getTableData();
    },
    async pageInit() {
      const listTreeCityData = await listTreeCityOnlyBeijing();
      const typeListData = await typeList();
      this.treeCityList = listTreeCityData.data.treeList;
      this.projectCat = typeListData.data;
      this.projectCat.unshift({ id: "", name: "全部" });
      this.getListPolicyAreasData({
        id: listTreeCityData.data.currentArea.cityCode,
        name: listTreeCityData.data.currentArea.city,
      });
    },
    getTableHeight() {
      let timer;
      if (timer) {
        clearTimeout(timer);
      }
      timer = setTimeout(() => {
        this.tableHeight =
          document.documentElement.clientHeight -
          document.getElementById("b").offsetTop -
          165;
      }, 60);
    },
  },
  created() {
    this.pageInit();
    this.$nextTick(() => {
      this.getTableHeight();
    });
  },
  mounted() {
    window.addEventListener("resize", this.getTableHeight);
    this.$once("hook:destroyed", () => {
      window.removeEventListener("resize", this.getTableHeight);
    });
  },
  // watch: {
  //   $route: {
  //     immediate: true,
  //     handler(val) {
  //       if (val.query) {
  //         console.log(val.query);
  //         this.queryParam = val.query;
  //       }
  //     },
  //     deep: true,
  //   },
  // },
};
</script>
<style lang="less" scoped>
@bgColor: #fff;
.padding_none {
  padding: 0;
}
.text-r {
  text-align: right;
  display: inline-block;
  width: 70px;
}
.text_tag {
  color: red;
}
.totalColor {
  display: inline-block;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 14px;
  span {
    color: #ff4e00;
  }
}
.line {
  height: 10px;
  width: auto;
  background: #eff2f5;
}
.cursor {
  cursor: pointer;
}
.policyDocuments {
  height: 100%;
  // padding: 10px;
  .t {
    background-color: @bgColor;
    padding: 20px;
  }
  .line {
    height: 10px;
    background: #eff2f5;
  }
  .b {
    background-color: @bgColor;
    padding: 20px 20px 0 20px;
    .flex {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
    }
  }
  ::v-deep .ant-table-pagination.ant-pagination {
    margin-bottom: 5px;
  }
  ::v-deep .ant-tabs-tab-active {
    font-weight: 500;
    color: #333;
    font-size: 16px;
    padding: 12px 0;
  }
  ::v-deep .ant-tabs-ink-bar {
    width: 64px;
  }
  .city {
    margin-bottom: 26px;
    height: 14px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 14px;
    .ant-btn {
      color: #0072f7;
      height: 14px;
      line-height: 14px;
    }
  }
  .filter_item {
    display: flex;
    justify-content: space-between;
    margin-bottom: 0px;
    &.policyArea_more {
      height: 24px;
      margin-bottom: 15px;
      overflow: hidden;
    }
    .title {
      width: 70px;
      line-height: 24px;
    }
    div {
      flex: 1;
      display: flex;
      flex-wrap: wrap;
      .option_item {
        height: 24px;
        line-height: 24px;
        margin-right: 10px;
        margin-bottom: 15px;
        padding: 0px 10px;
        cursor: pointer;
        //min-width: 76px;
        text-align: center;
      }
    }
    ::v-deep .ant-btn > .anticon + span,
    .ant-btn > span + .anticon {
      margin-left: 4px;
    }
    .ant-btn-link {
      color: #0072f7;
    }
    ::v-deep .ant-btn {
      color: #999;
      width: 80px;
    }
    span {
      font-size: 14px;
      font-weight: 400;
    }
    // span:nth-child(2) {
    //   margin-left: 10px;
    // }
    .more {
      // float: right;
      font-size: 14px;
      font-weight: 400;
      color: #999;
      cursor: pointer;
    }
    .more::after {
      content: "";
      display: inline-block;
      width: 7px;
      height: 7px;
      margin-left: 5px;
      transform: rotate(45deg);
      border-right: 1px solid #999;
      border-bottom: 1px solid #999;
      vertical-align: 2px;
    }
    .active {
      height: 24px;
      line-height: 24px;
      background: #0072f7;
      border-radius: 4px;
      color: @bgColor;
    }
  }
  .search {
    width: 300px;
    height: 32px;
    padding-left: 10px;
    padding-right: 28px;
    background: @bgColor;
    border-radius: 2px;
    border: 1px solid #e0e0e0;
    font-size: 14px;
    font-weight: 400;
    outline: none;
  }
  .search::-webkit-input-placeholder {
    color: #dddddd;
  }
  .search::-ms-input-placeholder {
    color: #dddddd;
  }
  .search::-moz-placeholder {
    color: #dddddd;
  }
  .search_icon {
    width: 14px;
    height: 14px;
    margin-left: -28px;
    color: #0072f7;
    cursor: pointer;
    z-index: 1;
  }
}
::v-deep .ant-table-thead > tr > th {
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
  line-height: 14px;
  padding: 12px 16px;
}
::v-deep .ant-table-tbody > tr > td {
  padding: 9px 16px;
}
// ::v-deep .ant-table-wrapper {
//   margin-right: -20px;
// }
</style>
